import { useState } from "react";
import { formatText, useTexts } from "../texts";
import { Notice } from "../ui/kit";
import { RadioCards, useIsMobile, Window } from "./widgets";
import styles from "./ai.module.css";

/** Valor de «Sin razonar» en las tarjetas; en la cadena es una fila sin nivel. */
const OFF = "OFF";

/** Nombre de un nivel de razonamiento; sin nivel, «Sin razonar». */
export const reasoningName = (L: (key: string) => string, level: string | null | undefined) =>
  L(`ADM_AI_REASONING_${level ?? OFF}`);

/**
 * C08 · Cuánto razona el modelo de una fila de la cadena: «Sin razonar» y los niveles que ese modelo admite, en tarjetas
 * de opción con su efecto a la vista. Se guarda al elegir «Guardar»; quien abre la ventana da «Deshacer» en su aviso.
 */
export function ReasoningWindow({
  modelName,
  providerName,
  level,
  levels,
  busy,
  failure,
  onClose,
  onSave,
}: {
  modelName: string;
  providerName: string;
  level: string | null;
  levels: string[];
  busy: boolean;
  failure: string | null;
  onClose: () => void;
  onSave: (level: string | null) => void;
}) {
  const { L } = useTexts();
  const mobile = useIsMobile();
  const [value, setValue] = useState(level ?? OFF);
  const save = () => {
    if (busy) return;
    const next = value === OFF ? null : value;
    if (next === level) onClose();
    else onSave(next);
  };
  return (
    <Window
      open
      title={L("ADM_AI_REASONING")}
      className={styles.priceWindow}
      onClose={onClose}
      footer={
        <>
          {mobile ? null : (
            <button type="button" className="tm-btn secondary" onClick={onClose} disabled={busy}>
              {L("ACTION_CANCEL")}
            </button>
          )}
          <button type="button" className="tm-btn primary" disabled={busy} aria-busy={busy || undefined} onClick={save}>
            {L("ADM_AI_SAVE")}
          </button>
        </>
      }
    >
      <div className={styles.windowBlock} data-part="ventana">
        <p className={styles.priceWindowLine}>{formatText(L("ADM_AI_REASONING_LINE"), modelName, providerName)}</p>
        {failure ? <Notice tone="error">{failure}</Notice> : null}
        <RadioCards
          label={L("ADM_AI_REASONING")}
          value={value}
          options={[OFF, ...levels].map((code) => ({
            value: code,
            title: L(`ADM_AI_REASONING_${code}`),
            line: L(`ADM_AI_REASONING_${code}_LINE`),
          }))}
          onChange={setValue}
        />
      </div>
    </Window>
  );
}
